// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__cOQNQ","footerNoMargin":"Footer_footerNoMargin__MRUgy","footerSubscribe":"Footer_footerSubscribe__tgXdd"};